module.exports = __webpack_public_path__ + "public/img/sk2.6cd8c2d0.png";